require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./cours-et-plans-dtudes-bachelor-2-1-1.json") })
        }
      }, "path---cours-et-plans-dtudes-bachelor-2-1-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---cours-et-plans-dtudes-bachelor-2-1-1!./.cache/json/cours-et-plans-dtudes-bachelor-2-1-1.json
// module id = 385
// module chunks = 231608221292675